/*--------------------------------------
SLIDER VERTICAL
 --------------------------------------*/
SliderVertical = {
    init: function () {
        var swiper = new Swiper(".swiper-blog-images", {
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-blog-images-next",
                prevEl: ".swiper-blog-images-prev",
            },
        });

    }
};


/*----------------------
 STICKY
 ----------------------*/
Sticky = {
    init: function () {
        function sticky() {
            var height_menu = $(".header-menu__content").outerHeight();
            var height_div = $(".article-content--text").outerHeight() + height_menu;
            var height_window = $(window).height();

            if (height_div > height_window) {
                var result = height_div - height_window - height_menu;
                $(".article-content--text").css("top", -result);
            } else {
                $(".article-content--text").css("top", height_menu);
            }
        }
        sticky();

        $(window).on("resize", function () {
            sticky();
        });
    }
};

$(document).ready(function () {
    SliderVertical.init();
    Sticky.init();
});
$(document).on('shopify:section:load', function (event) {
    SliderVertical.init();
    Sticky.init();
})